<template>
    <div class="fab-item">
        <div class="first">
            <div class="icon">
                <img
                    v-show="true"
                    :src="`/static/img/fabImages/${clone.type}Icon.svg`"
                    class="fab-icon"
                    height="40px"
                    width="40px"
                />
            </div>
            <div class="texts">
                <div class="feature-title title-color">
                    {{ metas[clone.type].title }}
                </div>
                <div class="feature-description">
                    {{ metas[clone.type].description }}
                </div>
            </div>
        </div>
        <div class="second">
            <a-button ghost type="primary" v-if="!clone.enable" @click="connect" :disabled="!isFabsActive">
                {{ $t("settings.connected") }}
            </a-button>
            <div :class="{ 'text-success': isFabsActive, 'd-none': !isFabsActive }" v-else>
                <a-icon type="check" />
                {{ $t("settings.connected") }}
            </div>

            <a-button ghost type="danger" v-if="clone.enable" @click="clone.enable = false" :disabled="!isFabsActive">
                {{ $t("settings.remove") }}
            </a-button>
            <a-button
                ghost
                type="primary"
                v-if="clone.enable && isEditableFab()"
                @click="showModal = true"
                :disabled="!isFabsActive"
            >
                {{ $t("settings.edit") }}
            </a-button>
        </div>
        <Modal2
            v-if="showModal"
            @cancel="showModal = false"
            @ok="showModal = false"
            show-footer
            :ok-text="$t('common.save')"
            :title="metas[clone.type].modalTitle"
            :description="metas[clone.type].modalDescription"
        >
            <WhatsappActionForm v-if="clone.type === 'whatsapp'" v-model="clone" />
            <PhoneActionForm v-else-if="clone.type === 'phone'" v-model="clone" />
            <EmailActionForm v-else-if="clone.type === 'email'" v-model="clone" />
            <FacebookActionForm v-else-if="clone.type === 'facebook'" v-model="clone" />
            <TiwitterActionForm v-else-if="clone.type === 'twitter'" v-model="clone" />
            <InstagramActionForm v-else-if="clone.type === 'instagram'" v-model="clone" />
            <YouTubeActionForm v-else-if="clone.type === 'youtube'" v-model="clone" />
            <Linkedin v-else-if="clone.type === 'linkedin'" v-model="clone" />
            <Telegram v-else-if="clone.type === 'telegram'" v-model="clone" />
        </Modal2>
    </div>
</template>

<script>
import * as _ from "lodash";
import log2 from "../../../../utils/log2";
import { mapState } from "vuex";
import Modal2 from "../../../../components/common/Modal2.vue";
import WhatsappActionForm from "./WhatsappActionForm.vue";
import PhoneActionForm from "./PhoneActionForm.vue";
import EmailActionForm from "./EmailActionForm.vue";
import FacebookActionForm from "./FacebookActionForm.vue";
import TiwitterActionForm from "./TiwitterActionForm.vue";
import InstagramActionForm from "./InstagramActionForm.vue";
import YouTubeActionForm from "./YouTubeActionForm.vue";
import Linkedin from "./Linkedin.vue";
import Telegram from "./Telegram.vue";

const log = log2("FABItem");
export default {
    name: "FABItem",
    components: {
        Modal2,
        WhatsappActionForm,
        PhoneActionForm,
        EmailActionForm,
        FacebookActionForm,
        TiwitterActionForm,
        InstagramActionForm,
        YouTubeActionForm,
        Linkedin,
        Telegram,
    },
    props: {
        value: {
            type: Object,
            required: true,
        },
        iconEnabled: {
            type: Boolean,
        },
    },
    data() {
        return {
            clone: _.cloneDeep(this.value),
            metas: {
                live: {
                    icon: "",
                    title: this.$t(`message.liveFabListDescription`),
                    description: this.$t(`settings.liveSupportDescription`),
                },
                ticket: {
                    icon: "",
                    title: this.$t(`message.ticketFabListDescription`),
                    description: this.$t(`settings.ticketDescription`),
                },
                whatsapp: {
                    icon: "",
                    title: this.$t(`message.whatsappFabListDescription`),
                    description: this.$t("settings.whatsappDescription"),
                    modalTitle: this.$t("settings.whatsappModalTitle"),
                    modalDescription: this.$t("settings.whatsappModalDescription"),
                },
                phone: {
                    icon: "",
                    title: this.$t(`message.phoneFabListDescription`),
                    description: this.$t("settings.phoneDescription"),
                    modalTitle: this.$t("settings.phoneModalTitle"),
                    modalDescription: this.$t("settings.phoneModalDescription"),
                },
                email: {
                    icon: "",
                    title: this.$t(`message.emailFabListDescription`),
                    description: this.$t("settings.emailDescription"),
                    modalTitle: this.$t("settings.emailModalTitle"),
                    modalDescription: this.$t("settings.emailModalDescription"),
                },
                facebook: {
                    icon: "",
                    title: this.$t(`message.facebookFabListDescription`),
                    description: this.$t("settings.facebookDescription"),
                    modalTitle: this.$t("settings.facebookModalTitle"),
                    modalDescription: this.$t("settings.facebookModalDescription"),
                },
                twitter: {
                    icon: "",
                    title: this.$t(`message.twitterFabListDescription`),
                    description: this.$t("settings.twitterDescription"),
                    modalTitle: this.$t("settings.twitterModalTitle"),
                    modalDescription: this.$t("settings.twitterModalDescription"),
                },
                instagram: {
                    icon: "",
                    title: this.$t(`message.instagramFabListDescription`),
                    description: this.$t("settings.instagramDescription"),
                    modalTitle: this.$t("settings.instagramModalTitle"),
                    modalDescription: this.$t("settings.instagramModalDescription"),
                },
                youtube: {
                    icon: "",
                    title: this.$t(`message.youtubeFabListDescription`),
                    description: this.$t("settings.youtubeDescription"),
                    modalTitle: this.$t("settings.youtubeModalTitle"),
                    modalDescription: this.$t("settings.youtubeModalDescription"),
                },
                linkedin: {
                    icon: "",
                    title: this.$t(`message.linkedinFabListDescription`),
                    description: this.$t("settings.linkedinDescription"),
                    modalTitle: this.$t("settings.linkedinModalTitle"),
                    modalDescription: this.$t("settings.linkedinModalDescription"),
                },
                telegram: {
                    icon: "",
                    title: this.$t(`message.telegramFabListDescription`),
                    description: this.$t("settings.telegramDescription"),
                    modalTitle: this.$t("settings.telegramModalTitle"),
                    modalDescription: this.$t("settings.telegramModalDescription"),
                },
            },
            showModal: false,
        };
    },
    computed: {
        ...mapState({
            isFabsActive: (state) => _.get(state.setting.settings, "fab.isFabsActive"),
        }),
    },
    methods: {
        isEditableFab() {
            return !["live", "ticket"].includes(this.clone.type);
        },
        connect() {
            this.clone.enable = true;
            if (this.isEditableFab()) {
                this.showModal = true;
            }
        },
    },
    watch: {
        clone: {
            handler(val) {
                log("updated", val);
                this.$emit("input", val);
            },
            deep: true,
        },
    },
};
</script>

<style scoped lang="scss">
.fab-item {
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding: 5px 10px;
    height: 60px;
    border: 1px solid var(--color-border-default);
    border-radius: 4px;
    background: var(--color-bg-neutral-default);

    &:hover {
        background: var(--color-bg-neutral-hover);
        border: 1px solid var(--color-border-hover);
    }

    .first {
        display: flex;
        align-items: center;
        gap: 20px;

        .icon {
            svg {
                width: 40px;
                height: 40px;
                fill: var(--color-bg-primary-default);
            }
        }

        .feature-title {
            font-size: 16px;
            font-weight: 500;
            color: var(--color-text-strong-default);
        }

        .feature-description {
            font-size: 14px;
            font-weight: 400;
            color: var(--color-text-low-default);
        }
    }

    .second {
        display: flex !important;
        align-items: center !important;
        gap: 5px;

        .ant-switch-checked {
            background-color: var(--color-bg-primary-default);
        }

        .number-wrapper {
            display: flex;
            gap: 5px;
            align-items: center;
        }
    }
}
</style>
